/**
 * Block is used on framework/vc-elements/carehome/block-carehome-accordion.php
 *
 * @returns {{toggleState(): void, state: boolean}}
 */
export default () => ({
    state: false,

    toggleState() {
        this.state = !this.state;
    }
})